import { render, staticRenderFns } from "./DefaultModuleLayout.vue?vue&type=template&id=4bab72f5"
import script from "./DefaultModuleLayout.vue?vue&type=script&lang=js"
export * from "./DefaultModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports